module.exports = __webpack_public_path__ + "static/optage-9caf44deee961b912613bd9b3d41d5ad.svg";